import React, { FC, useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useHttpClient } from '@wix/fe-essentials-standalone';
import { SkeletonRectangle } from '@wix/design-system';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import { exploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { useBi } from '@components/Hooks/useBi';
import { setCurrencyPreferencesRest } from '@utils/currency';

const DynamicCurrencySelector = dynamic(
  () => import('@components/Header/CurrencySelector'),
  {
    loading: () => <SkeletonRectangle height={'12px'} width={'72px'} />,
    ssr: false,
  },
);

const DynamicMobileCurrencySettings = dynamic(
  () => import('@components/Explore/CurrencySettings/MobileCurrencySettings'),
  {
    loading: () => <SkeletonRectangle height={'12px'} width={'24px'} />,
    ssr: false,
  },
);

interface CurrencySettingsProps {
  isMobileView?: boolean;
  sessionId?: string;
}

const CurrencySettings: FC<CurrencySettingsProps> = ({
  isMobileView,
  sessionId,
}) => {
  const logger = useBi();
  const httpClient = useHttpClient();
  const { userCurrency, localeDataTranslations } = useHeaderContext();

  const setCurrencyPreferences = async (value: string) => {
    await setCurrencyPreferencesRest({ value, httpClient });
    window.location.reload();
  };

  const onSelectCurrency = useCallback(
    (option: any) => {
      logger.report(
        exploreResultsPageGenericClick({
          clickType: 'choose currency',
          sessionId,
          data: JSON.stringify(option.id),
          exploreVersion: 'V2',
        }),
      );
      setCurrencyPreferences(option.id);
    },
    [logger],
  );

  return isMobileView ? (
    <DynamicMobileCurrencySettings
      value={userCurrency}
      localeDataTranslations={localeDataTranslations}
      onChange={(option) => {
        onSelectCurrency(option);
      }}
    />
  ) : (
    <DynamicCurrencySelector
      value={userCurrency}
      onChange={(option) => {
        onSelectCurrency(option);
      }}
      localeDataTranslations={localeDataTranslations}
      isLess1000View={isMobileView}
      type="button"
    />
  );
};

export default CurrencySettings;
